<template>
  <SHeaderBase>
    <template #left>
      <HeaderNavDropdown
        v-if="hasProjectsMenu"
        class="s-header-main__projects"
        :label="tr('main_site.layout.header_products_button')"
      >
        <HeaderProjectsMenu />
      </HeaderNavDropdown>
    </template>

    <template #right>
      <div v-if="!isAuthenticated" class="s-header-main__company-registration">
        <SButton
          action-type="tertiary-soft"
          :href="ziggyUnsafe('client.pro.customer_registration')"
          size="sm"
          tag="a"
        >
          {{ tr("main_site.layout.header_to_customer") }}
        </SButton>
      </div>

      <div class="s-header-main--mobile-hidden">
        <SButtonSearch
          :aria-label="tr('main_site.layout.header_search_placeholder')"
          :placeholder="tr('main_site.layout.header_search_placeholder')"
          @search="onSearch"
        />
      </div>
      <HeaderMobileSearch v-if="!hasProjectsMenu" />

      <div class="s-header-main__login">
        <SButton
          v-if="!isAuthenticated"
          :href="ziggyUnsafe('auth.login')"
          prefix-icon="far fa-arrow-right"
          size="sm"
          tag="a"
          :title="tr('main_site.layout.header_login')"
        >
          {{ tr("main_site.layout.header_login") }}
        </SButton>
        <SButton
          v-else
          :href="mySolvariLink"
          prefix-icon="fas fa-user"
          size="sm"
          tag="a"
        >
          {{ mySolvariLabel }}
        </SButton>
      </div>
      <HeaderMobileMenu v-if="hasProjectsMenu" />
    </template>
  </SHeaderBase>
</template>

<script setup lang="ts">
import { computed } from "vue";

import { SButton, SButtonSearch } from "@solvari/common-fe";
import { ziggyUnsafe } from "@solvari/common-fe/integrations";
import { useI18nMainSiteLayout } from "@solvari/translations";

import HeaderMobileMenu from "./HeaderMobileMenu.vue";
import HeaderMobileSearch from "./HeaderMobileSearch.vue";
import HeaderNavDropdown from "./HeaderNavDropdown.vue";
import HeaderProjectsMenu from "./HeaderProjectsMenu.vue";
import SHeaderBase from "./SHeaderBase.vue";
import { useNavigation } from "./useNavigation";

withDefaults(
  defineProps<{
    isAuthenticated?: boolean;
    mySolvariLabel?: string;
    mySolvariLink?: string;
  }>(),
  {
    isAuthenticated: false,
  },
);

const { tr } = useI18nMainSiteLayout();
const { isNavigationEnabled, navigationConfig } = useNavigation();

const hasProjectsMenu = computed(() => {
  return isNavigationEnabled.value && navigationConfig.value !== null;
});

function onSearch(term: string) {
  window.location.href = `${ziggyUnsafe("client.search.base")}?term=${encodeURIComponent(term)}`;
}
</script>

<style lang="postcss">
.s-header-main {
  &__company-registration {
    @apply hidden;

    @screen 1000 {
      @apply inline-flex;
    }
  }

  &--mobile-hidden {
    @apply hidden;

    @screen 1000 {
      @apply grid;
    }
  }

  &__projects {
    @apply hidden;

    @screen 1000 {
      @apply flex;
    }
  }
}
</style>
